import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { DocumentsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';

@Component({
    'selector': 'app-termsOfService',
    'templateUrl': './termsOfService.page.html',
    'styleUrls': ['./termsOfService.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class TermsOfServicePage extends ViewBasePage implements OnInit {
    public myHTML = {};

    constructor(private documentsService: DocumentsService, private domSanitizer: DomSanitizer, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_TERMS_OF_SERVICE);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.loadDocument();
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        // this.resetPopoverMenu();
        // this.pushPopoverMenuItem('Show Tour', 'show-terms-of-service-tour');
    }

    public async loadDocument() {
        try {
            await this.uxHelperService.showSpinner('Loading data.');
            const metaData = this.documentsService.getDocumentMetaDataByViewName(Constants.VIEW_TERMS_OF_SERVICE);
            const doc = await this.documentsService.getByUid(metaData.uid);
            // console.log('doc.contents = ', doc.contents);
            
            // The doc file may have data.test = xxx.  By default this is considered to be
            // dangerous code and is removed.  Prevent the removal by bypassing this security.
            const trustedDoc = this.domSanitizer.bypassSecurityTrustHtml(doc.contents);
            this.myHTML = trustedDoc;
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            const msg = errorMessage || 'Terms of Service document not found.';
            this.uxHelperService.showAlert('Error', msg);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }
}
